(function () {
  const seeAllThreshold = 8;

  function initFilterDrawer(root) {
    const filter =
      root.querySelector?.("#filterContent") ||
      document.getElementById("filterContent");
    if (!filter || filter.dataset.focusViewInitialized === "true") return;

    const scrollContainer = filter.querySelector(".popup-content-inner");
    const focusHeader = filter.querySelector("[data-filter-focus-header]");
    const focusTitle = filter.querySelector("[data-filter-focus-title]");
    const backButton = filter.querySelector("[data-filter-focus-back]");
    const clearAllButton = filter.querySelector("[data-filter-clear-all]");
    const searchAllInput = filter.querySelector("[data-filter-search-all]");
    const searchAllResults = filter.querySelector(
      "[data-filter-search-results]",
    );
    const searchStyle = filter.dataset.filterSearchStyle || "single";

    if (!focusHeader || !focusTitle || !backButton) return;

    filter.dataset.focusViewInitialized = "true";
    let focusedFacet = null;
    let previousScrollTop = 0;
    let focusReturnTimer = null;
    let focusReturnFacet = null;
    let focusReturnHandler = null;
    let focusRestoreTimer = null;

    function facetGroups() {
      return Array.from(filter.querySelectorAll("algolia-refinement-list"));
    }

    function facetSearchConfig(facet) {
      const configs = {
        product_type: {
          placeholder: "Search product types...",
          label: "Search product types",
        },
        metafield_product_subtype: {
          placeholder: "Search subtypes...",
          label: "Search product subtypes",
        },
        vendor: {
          placeholder: "Search manufacturers...",
          label: "Search manufacturers",
        },
      };

      return configs[facet.dataset.attribute] || null;
    }

    function applyFacetSearch(facet, value) {
      const query = value.trim().toLocaleLowerCase();
      const isSearching = query.length > 0;

      facet.classList.toggle("is-filter-searching", isSearching);
      facet.querySelectorAll(".checkbox-container").forEach(function (item) {
        const label = item.querySelector(".filter-label")?.textContent || "";
        item.hidden = isSearching && !label.toLocaleLowerCase().includes(query);
      });
    }

    function ensureFacetSearch(facet, wrapper, list) {
      if (searchStyle !== "individual") return;

      const config = facetSearchConfig(facet);
      if (!config) return;

      let search = wrapper.querySelector(":scope > .collection-filter-search");
      if (!search) {
        search = document.createElement("label");
        search.className = "collection-filter-search";
        search.innerHTML =
          '<span class="collection-filter-search__icon" aria-hidden="true"></span>' +
          '<input type="search" autocomplete="off">';

        const input = search.querySelector("input");
        input.placeholder = config.placeholder;
        input.setAttribute("aria-label", config.label);
        input.addEventListener("input", function () {
          applyFacetSearch(facet, input.value);
        });
        wrapper.insertBefore(search, list);
      }

      const input = search.querySelector("input");
      if (input?.value) applyFacetSearch(facet, input.value);
    }

    function choiceGroup(source) {
      const group = source.closest(
        "algolia-refinement-list, algolia-rating-menu, algolia-toggle-filter",
      );
      return (
        group?.dataset.heading ||
        group?.querySelector(".filter-group_title .fw700")?.textContent ||
        "Filters"
      ).trim();
    }

    function searchChoices(query) {
      const choices = [];

      filter
        .querySelectorAll(
          ".collection-filters_form:not(.skeleton) .checkbox-container",
        )
        .forEach(function (item) {
          const input = item.querySelector('input[type="checkbox"]');
          const labelElement =
            item.querySelector(".filter-label") || item.querySelector("label");
          const label = labelElement?.textContent?.trim() || "";
          if (!input || !label) return;

          choices.push({
            group: choiceGroup(item),
            label: label,
            selected: input.checked,
            source: input,
          });
        });

      filter
        .querySelectorAll(
          ".collection-filters_form:not(.skeleton) .rating-filter-row",
        )
        .forEach(function (row) {
          const label =
            row.getAttribute("aria-label") || row.textContent.trim();
          if (!label) return;

          choices.push({
            group: choiceGroup(row),
            label: label,
            selected: row.classList.contains("refined"),
            source: row,
          });
        });

      return choices.filter(function (choice) {
        const searchableText = `${choice.label} ${choice.group}`;
        return searchableText.toLocaleLowerCase().includes(query);
      });
    }

    function interleaveChoices(choices) {
      const groups = new Map();
      choices.forEach(function (choice) {
        if (!groups.has(choice.group)) groups.set(choice.group, []);
        groups.get(choice.group).push(choice);
      });

      groups.forEach(function (groupChoices) {
        groupChoices.sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
      });

      const ordered = [];
      while (ordered.length < 60) {
        let addedChoice = false;
        groups.forEach(function (groupChoices) {
          const choice = groupChoices.shift();
          if (!choice || ordered.length >= 60) return;
          ordered.push(choice);
          addedChoice = true;
        });
        if (!addedChoice) break;
      }

      return ordered;
    }

    function closeSearchResults(clearInput) {
      if (!searchAllInput || !searchAllResults) return;
      if (clearInput) searchAllInput.value = "";
      searchAllInput.setAttribute("aria-expanded", "false");
      searchAllInput.removeAttribute("aria-activedescendant");
      searchAllResults.hidden = true;
      searchAllResults.replaceChildren();
    }

    function renderSearchResults(value) {
      if (!searchAllInput || !searchAllResults) return;

      const query = value.trim().toLocaleLowerCase();
      searchAllResults.replaceChildren();

      if (!query) {
        closeSearchResults(false);
        return;
      }

      const choices = interleaveChoices(searchChoices(query));
      if (!choices.length) {
        const empty = document.createElement("p");
        empty.className = "collection-filter-search-empty";
        empty.textContent = "No matching filters";
        searchAllResults.appendChild(empty);
      } else {
        choices.forEach(function (choice, index) {
          const button = document.createElement("button");
          button.type = "button";
          button.id = `${searchAllResults.id}-option-${index}`;
          button.className = "collection-filter-search-option";
          button.setAttribute("role", "option");
          button.setAttribute("aria-selected", String(choice.selected));

          const label = document.createElement("span");
          label.className = "collection-filter-search-option__label";
          label.textContent = choice.label;

          const group = document.createElement("span");
          group.className = "collection-filter-search-option__group";
          group.textContent = choice.group;

          button.append(label, group);
          button.addEventListener("click", function () {
            choice.source.click();
            closeSearchResults(true);
          });
          searchAllResults.appendChild(button);
        });
      }

      searchAllResults.hidden = false;
      searchAllInput.setAttribute("aria-expanded", "true");
    }

    function updateClearAllButton() {
      if (!clearAllButton) return;
      const hasRefinements = Boolean(
        filter.querySelector(
          ".collection-filters_form:not(.skeleton) .jsFilterGroupClear:not(.none)",
        ),
      );
      clearAllButton.disabled = !hasRefinements;
      clearAllButton.setAttribute("aria-disabled", String(!hasRefinements));
    }

    function updateSeeAllButton(facet) {
      const details = facet.querySelector("details.filter-group");
      const wrapper = facet.querySelector(".filter-group-wrapper");
      const list = facet.querySelector(".filter-group_inner");
      if (!details || !wrapper || !list) return;

      let button = details.querySelector(":scope > .collection-filter-see-all");
      if (!button) {
        button = document.createElement("button");
        button.type = "button";
        button.className = "collection-filter-see-all";
        button.textContent = "See all results";
        wrapper.insertAdjacentElement("afterend", button);
      }

      const itemCount = list.querySelectorAll(".checkbox-container").length;
      const shouldShow = itemCount > seeAllThreshold;
      if (button.hidden === shouldShow) button.hidden = !shouldShow;

      list
        .querySelectorAll(".is-filter-overflow-item")
        .forEach(function (item) {
          item.classList.remove("is-filter-overflow-item");
        });

      ensureFacetSearch(facet, wrapper, list);
    }

    function enhanceFacets() {
      facetGroups().forEach(updateSeeAllButton);
      updateClearAllButton();
      if (searchAllInput?.value) renderSearchResults(searchAllInput.value);
    }

    function clearFocusReturnTransition() {
      if (focusReturnTimer) {
        window.clearTimeout(focusReturnTimer);
        focusReturnTimer = null;
      }
      if (focusReturnFacet && focusReturnHandler) {
        focusReturnFacet.removeEventListener(
          "animationend",
          focusReturnHandler,
        );
      }
      focusReturnFacet = null;
      focusReturnHandler = null;
      filter.classList.remove("is-filter-focus-returning");
    }

    function clearFocusRestoreTransition() {
      if (focusRestoreTimer) {
        window.clearTimeout(focusRestoreTimer);
        focusRestoreTimer = null;
      }
      filter.classList.remove("is-filter-focus-restoring");
    }

    function finishResetFocusView(restoreScroll, animateMainView) {
      clearFocusReturnTransition();
      if (!focusedFacet && !filter.classList.contains("is-filter-focus-active"))
        return;

      focusedFacet?.classList.remove("is-filter-focus-target");
      focusedFacet = null;
      filter.classList.remove("is-filter-focus-active");
      focusHeader.setAttribute("aria-hidden", "true");
      focusTitle.textContent = "";

      clearFocusRestoreTransition();
      if (animateMainView) {
        filter.classList.add("is-filter-focus-restoring");
        focusRestoreTimer = window.setTimeout(function () {
          clearFocusRestoreTransition();
        }, 220);
      }

      if (restoreScroll && scrollContainer) {
        requestAnimationFrame(function () {
          scrollContainer.scrollTop = previousScrollTop;
          filter.scrollTop = previousScrollTop;
        });
      }
    }

    function resetFocusView(restoreScroll, animate) {
      if (!focusedFacet && !filter.classList.contains("is-filter-focus-active"))
        return;

      const shouldAnimate =
        animate &&
        filter.classList.contains("active") &&
        filter.classList.contains("is-filter-focus-active") &&
        !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (!shouldAnimate) {
        finishResetFocusView(restoreScroll, false);
        return;
      }

      if (filter.classList.contains("is-filter-focus-returning")) return;

      focusReturnFacet = focusedFacet;
      filter.classList.add("is-filter-focus-returning");

      const finish = function () {
        finishResetFocusView(restoreScroll, true);
      };

      focusReturnHandler = function (event) {
        if (event.target !== focusReturnFacet) return;
        finish();
      };
      focusReturnFacet?.addEventListener("animationend", focusReturnHandler);
      focusReturnTimer = window.setTimeout(finish, 240);
    }

    function showFocusedFacet(facet) {
      resetFocusView(false, false);
      focusedFacet = facet;
      previousScrollTop = scrollContainer?.scrollTop || filter.scrollTop || 0;

      const details = facet.querySelector("details.filter-group");
      if (details) details.open = true;

      facet.classList.add("is-filter-focus-target");
      filter.classList.add("is-filter-focus-active");
      focusTitle.textContent = facet.dataset.heading || "Filter results";
      focusHeader.setAttribute("aria-hidden", "false");

      requestAnimationFrame(function () {
        if (scrollContainer) scrollContainer.scrollTop = 0;
        filter.scrollTop = 0;
      });
    }

    filter.addEventListener("click", function (event) {
      const clearAll = event.target.closest("[data-filter-clear-all]");
      if (clearAll) {
        event.preventDefault();
        event.stopPropagation();
        filter.dataset.clearingAll = "true";
        filter
          .querySelectorAll(
            ".collection-filters_form:not(.skeleton) .jsFilterGroupClear:not(.none)",
          )
          .forEach(function (button) {
            button.click();
          });
        requestAnimationFrame(function () {
          delete filter.dataset.clearingAll;
          updateClearAllButton();
        });
        return;
      }

      const seeAllButton = event.target.closest(".collection-filter-see-all");
      if (seeAllButton) {
        const facet = seeAllButton.closest("algolia-refinement-list");
        if (!facet) return;
        event.preventDefault();
        event.stopPropagation();
        showFocusedFacet(facet);
        return;
      }

      if (event.target.closest("[data-filter-focus-back]")) {
        event.preventDefault();
        event.stopPropagation();
        resetFocusView(true, true);
      }
    });

    filter.addEventListener("change", function () {
      requestAnimationFrame(updateClearAllButton);
    });

    searchAllInput?.addEventListener("input", function () {
      renderSearchResults(searchAllInput.value);
    });

    searchAllInput?.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeSearchResults(true);
        return;
      }

      if (event.key !== "ArrowDown" || searchAllResults?.hidden) return;
      const firstOption = searchAllResults.querySelector(
        ".collection-filter-search-option",
      );
      if (!firstOption) return;
      event.preventDefault();
      firstOption.focus();
      searchAllInput.setAttribute("aria-activedescendant", firstOption.id);
    });

    searchAllResults?.addEventListener("keydown", function (event) {
      const currentOption = event.target.closest(
        ".collection-filter-search-option",
      );
      if (!currentOption) return;

      const options = Array.from(
        searchAllResults.querySelectorAll(".collection-filter-search-option"),
      );
      const currentIndex = options.indexOf(currentOption);
      let nextOption = null;

      if (event.key === "ArrowDown") {
        nextOption = options[currentIndex + 1] || options[0];
      } else if (event.key === "ArrowUp") {
        nextOption = options[currentIndex - 1] || options.at(-1);
      } else if (event.key === "Escape") {
        closeSearchResults(false);
        searchAllInput.focus();
      }

      if (!nextOption) return;
      event.preventDefault();
      nextOption.focus();
      searchAllInput.setAttribute("aria-activedescendant", nextOption.id);
    });

    filter.addEventListener("click", function (event) {
      if (!event.target.closest(".collection-filter-search-all")) {
        closeSearchResults(false);
      }
    });

    const contentObserver = new MutationObserver(function (records) {
      const onlySearchResultsChanged = records.every(function (record) {
        return (
          record.target === searchAllResults ||
          record.target.closest?.("[data-filter-search-results]")
        );
      });
      if (!onlySearchResultsChanged) enhanceFacets();
    });
    contentObserver.observe(filter, { childList: true, subtree: true });

    const stateObserver = new MutationObserver(function () {
      if (!filter.classList.contains("active")) resetFocusView(false, false);
      if (filter.classList.contains("active")) enhanceFacets();
    });
    stateObserver.observe(filter, {
      attributes: true,
      attributeFilter: ["class"],
    });

    enhanceFacets();
  }

  function initStickyFilterShadows(root) {
    const scopes = Array.from(
      root.querySelectorAll?.(".collection-sticky-enabled") || [],
    );

    scopes.forEach(function (scope) {
      const stickyTarget =
        scope.querySelector(".parts-collection-sticky-stack") ||
        scope.querySelector(".filter-main-col > .collection-controls") ||
        scope.querySelector(
          ".filter-main-col > .collection-toolbar--legacy",
        );

      if (!stickyTarget || stickyTarget.dataset.stickyShadowInitialized) return;

      stickyTarget.dataset.stickyShadowInitialized = "true";

      const sentinel = document.createElement("span");
      sentinel.className = "collection-sticky-sentinel";
      sentinel.setAttribute("aria-hidden", "true");
      stickyTarget.before(sentinel);

      let updateFrame = null;

      const updateStickyState = function () {
        updateFrame = null;
        const styles = window.getComputedStyle(stickyTarget);
        const stickyTop = Number.parseFloat(styles.top);
        const isSticky = styles.position === "sticky";
        const hasReachedStickyPosition =
          sentinel.getBoundingClientRect().top <=
          (Number.isFinite(stickyTop) ? stickyTop : 0) + 0.5;

        stickyTarget.classList.toggle(
          "is-filter-stuck",
          isSticky && hasReachedStickyPosition,
        );
      };

      const scheduleStickyUpdate = function () {
        if (updateFrame !== null) return;
        updateFrame = window.requestAnimationFrame(updateStickyState);
      };

      window.addEventListener("scroll", scheduleStickyUpdate, {
        passive: true,
      });
      window.addEventListener("resize", scheduleStickyUpdate, {
        passive: true,
      });
      window.addEventListener("load", scheduleStickyUpdate, { once: true });

      if (window.ResizeObserver) {
        const resizeObserver = new ResizeObserver(scheduleStickyUpdate);
        resizeObserver.observe(stickyTarget);
        const header = document.getElementById("theme-header");
        if (header) resizeObserver.observe(header);
      }

      scheduleStickyUpdate();
    });
  }

  function init(root) {
    initFilterDrawer(root || document);
    initStickyFilterShadows(root || document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
